import { render, staticRenderFns } from "./UnorderedProducts.vue?vue&type=template&id=14e32590&scoped=true&"
import script from "./UnorderedProducts.vue?vue&type=script&lang=js&"
export * from "./UnorderedProducts.vue?vue&type=script&lang=js&"
import style0 from "./UnorderedProducts.vue?vue&type=style&index=0&id=14e32590&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e32590",
  null
  
)

export default component.exports